import React, { Component } from 'react';
import './css/style.css';
import firebase, { auth, provider } from './firebase.js';
// import Login from './components/Login';

class App extends Component {
  constructor() {
    super();
    this.state = {
      currentItem: '',
      username: '',
      items: [],
      user: null
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
  }
  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }
  login() {
    auth.signInWithPopup(provider) 
      .then((result) => {
        const user = result.user;
        this.setState({
          user
        });
      });
  }
  logout() {
    auth.signOut()
      .then(() => {
        this.setState({
          user: null
        });
      });
  }

  componentDidMount() {

    const itemsRef = firebase.database().ref('items');
    itemsRef.on('value', (snapshot) => {
      let items = snapshot.val();
      let newState = [];
      for (let item in items) {
        newState.push({
          id: item,
          title: items[item].title,
          user: items[item].user
        });
      }
      this.setState({
        items: newState
      });
    });
    auth.onAuthStateChanged((user) => {
      if (user) {
        this.setState({ user });
      } 
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    const itemsRef = firebase.database().ref('items');
    const item = {
      title: this.state.currentItem,
      user: this.state.user.displayName || this.state.user.email
    }
    console.log(item);
    itemsRef.push(item);
    this.setState({
      currentItem: '',
      username: ''
    });
  }

  removeItem(itemId) {
    const itemRef = firebase.database().ref(`/items/${itemId}`);
    itemRef.remove();
  }
  
  render() {
    return (
      <div className='app'>
        <header className='header'>
          <div className="wrapper  header__wrapper">

            {this.state.user ?
              <div className="wrapper__container">
                <div className="wrapper__container wrapper__container--logout">
                  <h1 className="header__title header__title--logout">Picnic</h1>
                  <div className="logout__container">
                    <button className='header__button' onClick={this.logout}><span className="background"></span>Logout</button>
                    <div className='user'>
                      <img className='user__img' src={this.state.user.photoURL} alt="user profile" />
                      {console.log(this.state)}
                    </div>
                  </div>
                </div>
              </div>
            :
            <div className="wrapper__container wrapper__container--login">
              <h1 className="header__title header__title--login">Picnic</h1>
              <button className='header__button' onClick={this.login}><span className="background"></span>Log In</button>
              <p className='header__text'>Login to see the picnic list and who is coming</p>
            </div>           
            }
          </div>
        </header>
        {this.state.user ?
          <main>
            <div className='container'>
            <div className="wrapper">
              <section className='addItem'>
                  <form className='addItem__form' onSubmit={this.handleSubmit}>
                  <p>hey {this.state.user.displayName.split(' ')[0]},</p>
                    {/* <input type="text" name="username" placeholder="What's your name?" onChange={this.handleChange} value={this.state.user.displayName.split(' ')[0]} /> */}
                    <div className="addItem__cursor">
                      <input className="addItem__input" type="text" name="currentItem" placeholder="what are you bringing?" onChange={this.handleChange} value={this.state.currentItem} />
                      <i className="addItem__icon"></i>
                    </div>
                    
                    <button className="addItem__button"><span className="background"></span>Add Item</button>
                  </form>
                </section>
            </div>
              
              <section className='cards'>
                <div className="wrapper">
                  <ul className='cards__list'>
                    {this.state.items.map((item) => {
                      return (
                        <li className='card' key={item.id}>
                          <div className="card__header">
                            <h3 className="card__title">{item.title}</h3>
                            {/* {console.log(this.state.user.displayName.split(' ')[0])} */}
                            {item.user === this.state.user.displayName || item.user === this.state.user.email ?
                            <i className="card__delete fa fa-times" onClick={() => this.removeItem(item.id)}></i> : null}
                            {console.log(item.user, this.state.user.displayName, item.user === this.state.user.displayName)}
                          </div>
                          
                          <p className="card__text">brought by: {item.user.split(' ')[0]}</p>
                          {/* {console.log(this.state.user.displayName)} */}
                        </li>
                      )
                    })}
                  </ul>
                </div>
              </section>
            </div>
          </main>
        : 
          <p></p>
        }
      </div>
    );
  }
}
export default App;